<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
import { IDEVIEWMODELS } from '@/utils/models'
import settingService from '@/services/ide/settings/setting.service'
import { useIdeStore } from '@/stores/ide.store'
import FeedbackPopup from '@/components/ide/ide/FeedbackPopup.vue'

const ideStore = useIdeStore()

const copySuccess = ref<boolean>(false)
const showCopiedMessageText = ref<string>('')
const copiedToClip = ref<boolean>(false)
const timeOut = ref<NodeJS.Timeout | number | null>(null)

const isCopied = computed(() => {
  return ideStore.isCopied
})
/**
 * Copy the project script to the  to clipboard
 */
const copyToClipboard = async () => {
  if (isCopied.value) {
    showCopiedMessageText.value = 'Copied to clipboard!'
    copySuccess.value = true
    copiedToClip.value = true
  }
  if (timeOut.value) clearTimeout(timeOut.value)
  timeOut.value = setTimeout(() => {
    copiedToClip.value = false
    copySuccess.value = false
    showCopiedMessageText.value = ''
    ideStore.setIsCopied(false)
    settingService.closePopup(IDEVIEWMODELS.COPY)
  }, 5000)
}

onMounted(() => {
  watch(isCopied, () => {
    copyToClipboard()
  })
})
</script>
<template>
  <FeedbackPopup>
    <div class="flex w-max min-w-[150px] max-w-[250px] pb-2 sm:max-w-xs lg:max-w-sm">
      <p class="p-xsmall pt-2 text-left">
        {{ showCopiedMessageText }}
      </p>
    </div>
  </FeedbackPopup>
</template>
